var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99997 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66059 0 9.99997 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99997 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66059 0 9.99997 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 9.88235C19.2941 14.9425 15.1409 19.0588 10 19.0588C4.8591 19.0588 0.705882 14.9425 0.705882 9.88235C0.705882 4.82218 4.8591 0.705882 10 0.705882C15.1409 0.705882 19.2941 4.82218 19.2941 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.41176
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 9.88235C19.2941 14.9425 15.1409 19.0588 10 19.0588C4.8591 19.0588 0.705882 14.9425 0.705882 9.88235C0.705882 4.82218 4.8591 0.705882 10 0.705882C15.1409 0.705882 19.2941 4.82218 19.2941 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.41176
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 13.7809H13.9768V9.6677V8.38437C13.9768 8.22052 13.8424 8.0879 13.6768 8.0879H13.424V5.68807C13.424 5.52422 13.2896 5.3916 13.124 5.3916H11.7908C11.6252 5.3916 11.4908 5.52422 11.4908 5.68807V8.0879H11.3574V5.68807C11.3574 5.52422 11.223 5.3916 11.0574 5.3916H9.724C9.5584 5.3916 9.424 5.52422 9.424 5.68807V8.0879H6.3232C6.1576 8.0879 6.0232 8.22052 6.0232 8.38437V9.6677V13.7809H5.3C5.1344 13.7809 5 13.9135 5 14.0774C5 14.2412 5.1344 14.3739 5.3 14.3739H14.7C14.8656 14.3739 15 14.2412 15 14.0774C15 13.9135 14.8656 13.7809 14.7 13.7809ZM12.824 5.98454V6.30888H12.0908V5.98454H12.824ZM12.0908 6.90182H12.824V8.0879H12.0908V6.90182ZM10.7574 5.98454V6.30888H10.024V5.98454H10.7574ZM10.024 6.90182H10.7574V8.0879H10.024V6.90182ZM6.6232 9.6677H13.3768V13.7809H9.3854V11.2584C9.3854 11.0945 9.251 10.9619 9.0854 10.9619H7.6594C7.4938 10.9619 7.3594 11.0945 7.3594 11.2584V13.7809H6.6232V9.6677Z",
    fill: "#3967BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4414 11.5549H12.1774C12.343 11.5549 12.4774 11.4222 12.4774 11.2584C12.4774 11.0945 12.343 10.9619 12.1774 10.9619H10.4414C10.2758 10.9619 10.1414 11.0945 10.1414 11.2584C10.1414 11.4222 10.2758 11.5549 10.4414 11.5549Z",
    fill: "#3967BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4414 12.3869H12.1774C12.343 12.3869 12.4774 12.2543 12.4774 12.0904C12.4774 11.9266 12.343 11.7939 12.1774 11.7939H10.4414C10.2758 11.7939 10.1414 11.9266 10.1414 12.0904C10.1414 12.2541 10.2758 12.3869 10.4414 12.3869Z",
    fill: "#3967BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4414 13.2194H12.1774C12.343 13.2194 12.4774 13.0868 12.4774 12.9229C12.4774 12.7591 12.343 12.6265 12.1774 12.6265H10.4414C10.2758 12.6265 10.1414 12.7591 10.1414 12.9229C10.1414 13.0868 10.2758 13.2194 10.4414 13.2194Z",
    fill: "#3967BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9.88235,
    fill: "white",
    transform: "translate(5 4.94141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacture);
export default __webpack_public_path__ + "static/media/manufacture.5a1ecf72f90a08aa2b070fe0c278a083.svg";
export { ForwardRef as ReactComponent };